import {useSyncExternalStore} from 'react';

import {infinityClientSignals} from '../signals/InfinityClient.signals';
import type {Meeting} from '../services/InfinityClient.service';

export const useMe = (getMe: Meeting['getMe']) => {
    return useSyncExternalStore(infinityClientSignals.onMe.add, getMe);
};
